import React from "react";
import PropTypes from 'prop-types';
import SelectedIcon from "./SelectedIcon";
import styles from './Dropdown.module.scss';
import {emptyFn} from "presentation/common/helpers/utils";

const Dropdown = ({list, onSelectItem, itemSelected, valueBind, labelBind}) => {
  return (
    <div className={styles.container}>
      <div className={styles.itemContainer}>
        {
          list.map((item) => {
            return (
              <div
                key={item[valueBind]}
                className="cursor-pointer w-full border-gray-100 rounded-t border-b hover:bg-teal-100"
                onClick={() => onSelectItem(item)}>
                <div className="flex w-full justify-between p-2 pl-2 border-transparent relative hover:bg-blue-100">
                  <span className="font-normal block truncate">
                     {item[labelBind]}
                  </span>

                  {
                    itemSelected && itemSelected[valueBind] === item[valueBind] &&
                    <span className="text-green-600 absolute inset-y-0 right-0 flex items-center pr-4">
                      <SelectedIcon/>
                    </span>
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

Dropdown.defaultProps = {
  valueBind: 'id',
  labelBind: 'name',
  items: [],
  onSelectItem: emptyFn
};

Dropdown.propTypes = {
  list: PropTypes.array,
  onSelectItem: PropTypes.func,
  itemSelected: PropTypes.object,
  valueBind: PropTypes.string,
  labelBind: PropTypes.string,
}

export default Dropdown;
